import { Box, Divider, useTheme, Grid, Typography, TextField, Button, Autocomplete } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";


import { fetchStockAndUpdateInventory } from "../common/FinishedGoodsInStock";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";

const LockReelLocation = ({ handleCallBack, stackingID, ReelID, locationCode, levelValue }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [reelList, setReelList] = useState([]);
    const [selectedReel, setSelectedReel] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    // reel details
    const [reelIdenfification, setReelIdentification] = useState(0);
    const [reelWeight, setReelWeight] = useState(0);
    const [size, setSize] = useState('');
    const [quality, setQuality] = useState('');
    const [gsm, setGSM] = useState('');
    const [diameter, setDiameter] = useState(0);
    const [core, setCore] = useState(0);



    const callback = () => {
        handleCallBack();
    }


    useEffect(() => {

        if (!isDataLoaded || ReelID === 0) {

            const para = {
                p_companyid: 1,
                p_reel_status: "open"
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_REEL_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setReelList(data);


                        if (ReelID > 0) {
                            const selectedData = data.find(detail => detail.id_reel === ReelID);
                            setSelectedReel(selectedData);
                            handleGetReelDetails(ReelID);
                        }
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);

    const handleGetReelDetails = (ReelID) => {
        setReelIdentification(ReelID);

        const para = { p_companyid: 1, p_id_child_reel: ReelID, }

        callApi(API_ENDPOINTS.WAREHOUSE_GET_REEL_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    // setPONumber(data);
                    setSize(data[0].d_width);
                    setReelWeight(data[0].quantity);
                    setQuality(data[0].quality);
                    setGSM(data[0].gsm);
                    setDiameter(data[0].diameter);
                    setCore(data[0].inner_core);

                }
            })
            .catch(error => {
                // callMessage('error', error.message, 'Error');
            });
    }




    const StoreReelToWarehouse = () => {
        // Validation: Check if any required parameter is null or undefined
        const requiredParameters = [
            { name: 'Location Code', value: locationCode },
            { name: 'Stacking Level', value: levelValue },
            { name: 'Reel Code', value: reelIdenfification },
            // { name: 'Sub Zone Code', value: subZone },
            { name: 'Stacking ID', value: stackingID },

        ];

        const missingParameter = requiredParameters.find(param => param.value === null || param.value === undefined || param.value === '');

        if (missingParameter) {
            alert(`Please provide a valid value for ${missingParameter.name}.`);
            return;
        }

        const parameter = {
            p_companyid: 1,
            p_id_stacking: stackingID,
            p_id_child_reel: reelIdenfification
        }



        callApi(API_ENDPOINTS.WAREHOUSE_INSERT_REEL_TO_WAREHOUSE, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {

                    const parameterNew = {
                        p_companyid: 1,
                        p_id_stacking: stackingID,
                        p_id_child_reel: reelIdenfification,
                        p_location_id: data[0].location_id,
                    }

                    fetchStockAndUpdateInventory(parameterNew)
                        .then(() => {
                            // Alert and callback only after successful completion of fetchStockAndUpdateInventory
                            alert('Reel Stored in Warehouse Location: ' + locationCode + ' Successfully');
                            callback();
                        })
                        .catch(error => {
                            alert(error.message);
                        });
                }
            })
            .catch(error => {
                alert(error.message);
            });
    };

    return (
        <Box>
            <Header title={'Set Reel Location'} subtitle="" callback={callback} />
            <Divider />
            <Box
                sx={{
                    padding: "5px",
                    borderRadius: "10px",
                    maxHeight: {
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '74vh', // Medium devices (small laptops)
                        lg: '74vh', // Large devices (desktops)
                        xl: '82vh', // Extra large devices (large desktops)
                    },
                    overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: colors.primary[400],
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: colors.blueAccent[600],
                        borderRadius: '10px',
                        '&:hover': {
                            background: colors.blueAccent[800],
                        },
                    },
                    '&::-webkit-scrollbar-corner': {
                        background: colors.primary[700],
                    }
                }}>

                <Grid container  >
                    <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12} >

                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" fontWeight="bold"> Location Code </Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    // label="Zone"
                                    variant="outlined"
                                    value={locationCode}
                                    // onChange={(e) => setZone(e.target.value)}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" fontWeight="bold"> Stacking Level </Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={0.5} xl={0.5}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    // label="Zone"
                                    variant="outlined"
                                    value={levelValue + 1}
                                    // onChange={(e) => setZone(e.target.value)}
                                    required
                                />
                            </Grid>
                        </Grid>

                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" > Reel Code </Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                {/* <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    required
                                /> */}
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    options={reelList}
                                    value={selectedReel}
                                    onChange={(event, newValue) => {
                                        setSelectedReel(newValue);
                                        // setSelectedPartyID(newValue.id);
                                        handleGetReelDetails(newValue.id_reel);
                                    }}
                                    getOptionLabel={(option) => option.code || ''}
                                    renderInput={(params) => (
                                        <TextField {...params} label="" required variant="outlined" />
                                    )}
                                />
                            </Grid>

                        </Grid>
                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" > Reel Size</Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                <TextField
                                    disabled
                                    fullWidth
                                    value={size}
                                    size="small"
                                    variant="outlined"
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" > Reel Weight </Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                <TextField
                                    disabled
                                    fullWidth
                                    value={reelWeight}
                                    size="small"
                                    variant="outlined"
                                    required
                                />
                            </Grid>
                        </Grid>

                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" > Quality</Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                <TextField
                                    disabled
                                    fullWidth
                                    value={quality}
                                    size="small"
                                    variant="outlined"
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" > GSM</Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                <TextField
                                    disabled
                                    fullWidth
                                    value={gsm}
                                    size="small"
                                    variant="outlined"
                                    required
                                />
                            </Grid>
                        </Grid>

                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" > Diameter</Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                <TextField
                                    disabled
                                    fullWidth
                                    value={diameter}
                                    size="small"
                                    variant="outlined"
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                <Typography variant="h6" > Core ID</Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                <TextField
                                    disabled
                                    fullWidth
                                    value={core}
                                    size="small"
                                    variant="outlined"
                                    required
                                />
                            </Grid>
                        </Grid>



                    </Grid>

                </Grid>
                <Divider sx={{ marginTop: '10px' }} />
                <Button onClick={StoreReelToWarehouse} size="small" variant="contained" color="secondary" sx={{ marginTop: '10px', marginLeft: '10px' }}>Save</Button>
            </Box>
        </Box>
    )
}
export default LockReelLocation;